import { useEffect, useState } from "react";
import { ambilDataAuth } from "../../lib/turnstile";
import "./masuk.css";

// PR login Google (INSTRUKSI 01/11/2026 bagian A1 & B): tombol = tautan GET biasa ke server (bukan form POST: CSP form-action 'self' memblokir
// pengalihan form ke accounts.google.com), tanpa skrip Google di situs. Tampil hanya bila server menyatakan login_google (Variables terisi).
// Logo "G" = aset resmi Google Sign-In (warna asli, tidak diubah); tombol tema gelap resmi.
export const LogoGoogle = () => (
  <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    <path fill="none" d="M0 0h48v48H0z" />
  </svg>
);

/** true bila tombol Google boleh tampil (server: GET /api/auth/turnstile → login_google). Belum datang / gagal = false. */
export function useLoginGoogle() {
  const [aktif, setAktif] = useState(false);
  useEffect(() => {
    let hidup = true;
    ambilDataAuth().then((d) => { if (hidup) setAktif(!!(d && d.login_google === true)); });
    return () => { hidup = false; };
  }, []);
  return aktif;
}

/** Jalur halaman asal (keranjang/checkout) yang boleh dibawa ke server; server memeriksanya lagi (jalurAman). */
export const dariAman = (d) => (typeof d === "string" && d.startsWith("/") && !d.startsWith("//") && !d.includes("\\") ? d : "/");

/** Kalimat persetujuan Masuk/Daftar (keputusan Haryanto 02/11/2026: satu baris .hs-setuju; 03/11/2026: Daftar hanya SATU kalimat = kalimat ini,
 *  di bawah tombol Google, atau di bawah "Buat Akun" bila Login Google mati). */
export function KalimatSetuju({ hp = false, tid = "google-syarat" }) {
  return (
    <p className={`${hp ? "hp-gelap__sk" : "hs-auth__sk"} hs-setuju`} data-testid={tid}>
      Anda menyetujui <a href="/syarat-ketentuan" target="_blank" rel="noopener noreferrer">Syarat dan Ketentuan</a> &amp;{" "}
      <a href="/kebijakan-privasi" target="_blank" rel="noopener noreferrer">Kebijakan Privasi</a>
    </p>
  );
}

/** Pemisah "atau" + tombol + kalimat persetujuan. hp = gaya halaman Masuk HP (hp-gelap), selain itu halaman komputer (hs-auth).
 *  aktif = hasil useLoginGoogle() pemanggil (Daftar memakainya juga untuk kalimat cadangan); tanpa prop = dibaca sendiri. */
export default function BagianGoogle({ dari, hp = false, aktif: aktifLuar }) {
  const aktifSendiri = useLoginGoogle();
  const aktif = aktifLuar === undefined ? aktifSendiri : aktifLuar;
  if (!aktif) return null;
  return (
    <>
      <div className="hs-atau" data-testid="google-atau">atau</div>
      <a href={`/api/auth/google/mulai?dari=${encodeURIComponent(dariAman(dari))}`} className={`hs-google ${hp ? "is-hp" : "is-hs-auth"}`} data-testid="tombol-google">
        <LogoGoogle /><span>Lanjutkan dengan Google</span>
      </a>
      <KalimatSetuju hp={hp} />
    </>
  );
}
